import { render, staticRenderFns } from "./WhiteLabelRequests.vue?vue&type=template&id=1305b42c&"
import script from "./WhiteLabelRequests.vue?vue&type=script&lang=js&"
export * from "./WhiteLabelRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports